// DatePickerHeader.tsx
import React, { FC } from 'react';
import { Box, Typography, Grid, IconButton } from '@mui/material';
import dayjs from 'dayjs';
import CloseIcon from '@mui/icons-material/Close';
import { StyledBox } from 'views/rebranded-module/GeoViewV2/components/DatePickerHeader/DatePickerHeader.styles';
import { Typography700 } from 'views/rebranded-module/common/components';
import { RiArrowRightSLine } from 'react-icons/ri';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const DatePickerHeader: FC<any> = (props) => {
const { pickupDate, dropoffDate, handelCloseCalenderClick } =props;
  const cmsData = useContent('GeoPage');
  const formatDate =(date)=>dayjs(date).format('MMMM D');

  return (
    <StyledBox
    >
   <Grid container spacing={0} className="showDESKTOP">
      <Grid item lg={6} md={6} sm={6}>
        <Box className={`${!pickupDate?'DPHActive':' '} DPHDateItem DPHPickupItem `}>
        <Typography700  className="DPHTitle" variant="overline3" component="p">
          {cmsData.pickupCalenderLabel}
        </Typography700>
        <Typography variant="body2" component="p" color="text.secondary" >
          {pickupDate ? formatDate(pickupDate) : cmsData.addDatePlaceHolder}
        </Typography>
      </Box>
    </Grid>

      {/* Dropoff */}
       <Grid item lg={6} md={6} sm={6}>
      <Box className={`${(pickupDate && !dropoffDate)?'DPHActive':' '} DPHDateItem`} >
        <Typography700 className="DPHTitle" variant="overline3" component="p">
          {cmsData.dropoffCalenderLabel}
        </Typography700>
        <Typography variant="body2"  component="p" color="text.secondary">
          {dropoffDate ? formatDate(dropoffDate): cmsData.addDatePlaceHolder}
        </Typography>
      </Box>
      </Grid>
      </Grid>
        {/* Arrow */}
      <Box className="DPHArrowContiner showDESKTOP">
        <RiArrowRightSLine className="DPHArrowIcon"/>
      </Box>
      <Box className="showTABLET">
        <IconButton className='DPHClose'  onClick={handelCloseCalenderClick}>
        <CloseIcon className="DPHCloseIcon" />
        </IconButton>
         <Typography700  variant="h7" component="p" my={1} mb={1}>
          {cmsData.calenderDialogTitleOnMobile}
        </Typography700>
      </Box>
    </StyledBox>
  );
};

export { DatePickerHeader };
